import { NavLink } from "react-router-dom";
import logoWhiteImg from "../assets/img/logo-white.svg";
import FireandvineFooterLogo from "../assets/icons/fireandvine_footer";
import eventIcon from "../assets/icons/event-icon.svg";
import locationIcon from "../assets/icons/location-icon.svg";
import dineinIcon from "../assets/icons/dinein.svg";
import { useState } from "react";
import { Icon } from "@iconify/react";

const Sidebar = () => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("accessToken");
    setShowLogoutConfirm(false);
    window.location.href = "/login";
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <div
        className="cm_sidebar"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        {/* <img className="cm_logo" src={logoWhiteImg} /> */}
        <div className="cm_logo">
          <FireandvineFooterLogo width="200" height="60" />
        </div>

        {/* Main navigation menu */}
        <ul style={{ flex: 1, margin: 0, padding: 0 }}>
          {/* <li><NavLink exact to="/" activeClassName="active"><img src={eventIcon} /> Dashboard</NavLink></li> */}
          <li>
            <NavLink to="/events" activeClassName="active">
              <img src={eventIcon} /> Events
            </NavLink>
          </li>
          <li>
            <NavLink to="/locations" activeClassName="active">
              <img src={locationIcon} /> Locations
            </NavLink>
          </li>
          <li>
            <NavLink to="/dinein" activeClassName="active">
              <img src={dineinIcon} /> Private Dining
            </NavLink>
          </li>
        </ul>

        <div
          style={{
            padding: "8px 20px",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <button
            onClick={handleLogout}
            className="logout-btn active"
            style={{
              background: "none",
              border: "none",
              color: "white",
              display: "flex",
              alignItems: "center",
              width: "100%",
              padding: "10px 15px",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.2s ease",
            }}
          >
            <Icon
              icon="material-symbols:logout"
              width="20"
              height="20"
              style={{ marginRight: "15px" }}
            />
            Logout
          </button>
        </div>
      </div>

      {showLogoutConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={cancelLogout}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "40px",
              borderRadius: "12px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
              border: "1px solid #e9ecef",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Logout Icon */}
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                border: "2px solid #e9ecef",
              }}
            >
              <Icon
                icon="material-symbols:logout"
                width="24"
                height="24"
                color="#6c757d"
              />
            </div>

            <h4
              style={{
                marginBottom: "12px",
                color: "#212529",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              Logout
            </h4>
            <p
              style={{
                marginBottom: "30px",
                color: "#6c757d",
                fontSize: "14px",
                lineHeight: "1.5",
              }}
            >
              Are you sure you want to logout from the admin panel?
            </p>
            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                onClick={cancelLogout}
                style={{
                  padding: "12px 24px",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  backgroundColor: "white",
                  color: "#6c757d",
                  cursor: "pointer",
                  minWidth: "100px",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#adb5bd";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.borderColor = "#dee2e6";
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                style={{
                  padding: "12px 24px",
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: "#00205B",
                  color: "white",
                  cursor: "pointer",
                  minWidth: "100px",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#0056b3";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#00205B";
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
